<template web>
  <!--<div id="matriz">
    <template v-if="funeat">
      <App />
    </template>
    <template v-else>
      <AppPropio />
    </template>
  </div>-->
  <v-app id="inspire" class="myFont">
    <div class="vh-100">
      <v-overlay v-if="loading" opacity="0">
        <v-container class="d-flex align-center justify-center flex-column">
          <h1 class="text--grey grey--text text--darken-4 mb-10">Cargando...</h1>
          <v-progress-circular size="50" width="8" indeterminate color="grey darken-4"></v-progress-circular>
        </v-container>
      </v-overlay>
      <router-view v-else />
    </div>
  </v-app>
</template>
<script>
import AppPropio from "./views/Propio/AppPropio";
import firebase from "firebase";
import { projectId } from "@/firebase";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    AppPropio
  },
  data() {
    return {
      funeat: true
    };
  },
  computed: {
    ...mapState({
      loading: state => state.app.loading
    })
  },
  mounted() {
    let _vm = this;
    if (projectId == "fun-eat") {
      this.$store.commit("app/setModoDesarrollo", "desarrollo");
    } else if (projectId == "fun-eat-produccion") {
      this.$store.commit("app/setModoDesarrollo", "produccion");
    }

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        return _vm.$store
          .dispatch("auth/checkLogin", user)
          .then(r => {})
          .catch(e => {
            return _vm.$store.dispatch("auth/firebaseLogout");
          })
          .finally(() => {
            _vm.$store.commit("app/setLoading", false);
          });
      } else {
        _vm.$store.commit("app/setLoading", false);
      }
    });
    //carga datos comunes
    _vm.$store.commit("app/setLoadingComunes", true);
    _vm.$store.dispatch("restaurante/cargaDatosComunes").finally(() => {
      _vm.$store.commit("app/setLoadingComunes", false);
      this.$store.commit("app/setRouter", this.$router);
    });
  }
};
</script>

<style>
</style>